module.exports = __webpack_public_path__ + "static/media/PhdCurriculum.b50a4887.pdf";